import React, { useState, useRef } from "react"
import * as JsSearch from "js-search"
import Image from "./image.js";
import { Link, navigate } from "gatsby";

const Search = () => {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [indexFetched, setFetched] = useState(false);
  const [isVisible, setVisible] = useState(false);
  const [search, setSearchData] = useState({});
  const [results, setResults] = useState([]);
  const form = useRef(null);
  
  const fetchIndex = async () => {
    let index = await fetch("/index.json");
    index = await index.json();
    setFetched(true);
    return index;
  }
  const buildIndex = (index) => {
    const dataToSearch = new JsSearch.Search("path");
    dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("path")
    dataToSearch.addIndex("path")
    dataToSearch.addIndex("name")
    dataToSearch.addDocuments(index)
    setSearchData(dataToSearch);
  }
  const submit = async (event) => {
    event.preventDefault();
    if (!indexFetched && !loading) {
      setLoading(true);
      const index = await fetchIndex();
      buildIndex(index);
      setLoading(false);
    }
    if (inputValue.length < 4 || loading) {
      return;
    }
    try {
      const queryResult = search.search(inputValue);
      setResults(queryResult.slice(0, 5));
    } catch(err) {
      console.error("search failed",err);
    }
  }
  const toggleVisibility = (event) => {
    event.preventDefault();
    setVisible(visibility => {
      return !visibility
    });
  }
  return <form
    id="search"
    className={isVisible ? "expanded":"collapsed"}
    ref={ form }
    onBlur={ (e) => {
      if (!form || !form.current) {
        return;
      }
      if (e.relatedTarget !== null && !form.current.contains(e.relatedTarget) && isVisible) {
        setVisible(false);
      }
    }}
    >
    <input
      type="search"
      placeholder="Search For Icons…"
      onChange={ (e) => { setInputValue(e.target.value) } }
      onKeyDown={ (e) => {
        if ((e.key === "Enter") && (inputValue.trim().length)) {
          e.stopPropagation();
          navigate("/search", {
            state: {
              query: inputValue
            }
          });
          return;
        }
      }}
      onKeyUp={ submit }
    />
    <button
      onClick={ toggleVisibility }
    >
      Show Search Form
    </button>
    <button
      onClick={ (e) => {
        e.preventDefault();
        if (!inputValue.trim().length) {
          return;
        }
        e.preventDefault();
        navigate("/search", {
          state: {
            query: inputValue
          }
        });
      } }
    >
      Search
    </button>
    { results.length
      ? (<ul>
        {
          results.map(result => {
            return (<li>
              <Link
                to={ "/"+result.path }
                title={ "View and download icon: "+result.name }
              >
                <Image
                  src={ result.icon }
                  alt={ result.name }
                />
                <span>{ result.name }</span>
                <span data-provider={ result.provider.slug } >{ result.provider.name }</span>
              </Link>
            </li>)
          })
        }
      </ul>)
      : <></>
    }
  </form>
}

export default Search;
